// Stable display-only grouping: never reorder the API response in place.
export function orderOperationsDapLast(operations) {
  const regular = [];
  const dap = [];
  for (const operation of Array.isArray(operations) ? operations : []) {
    (operation?.dap === true ? dap : regular).push(operation);
  }
  return [...regular, ...dap];
}
